import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=679ba8da&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=679ba8da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ba8da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('679ba8da')) {
      api.createRecord('679ba8da', component.options)
    } else {
      api.reload('679ba8da', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=679ba8da&scoped=true&", function () {
      api.rerender('679ba8da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2X5VA6L14AIik/JS/comp/DateRangeExt.vue"
export default component.exports